import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../common/spinner/loadSpinner";
import Menucustom from "../../common/menu/menucustom";
import DashboardSanzioneService from "../dashboard/dashboardSanzione/dashboardSanzioneService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jwt_decode from "jwt-decode";
import moment from "moment";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
  capitalizeFirstLetter,
  validCF,
} from "../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import externalLink from './export.png'

toast.configure();

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorCFTrasgessorePotesta: false,
      errorCFTrasgessore: false,
      data: [],
      dataTableSanzione: [],
      dataTableSanzioneCSV: [],
      dataTableSanzioneCSVLoad: "",
      headerDataTableSanzione: [],
      searchNumSanzione: "",
      searchDataEmissione: "",
      searchNome: "",
      idSanzionePerToast:0,
      searchCognome: "",
      searchCF: "",
      loading: true,
      showModalAggiungiSanzione: false,
      anagraficaSanzionato: false,
      isMinorenne: false,
      documentiSanzionati: false,
      residenzaSanzioanto: false,
      anagraficaSanzionatoPatriaPotesta: false,
      renderTableDataReload: false,
      dettagliSanzione: false,
      allegati: false,
      buttonCreaSanzione: true,

      nomeSanzionatoRequired: false,
      cognomeSanzionatoRequired: false,
      comuneDiResidenzaSanzionatoRequired: false,
      indirizzoSanzionatoRequired: false,
      provinciaSanzionatoRequired: false,
      capSanzionatoRequired: false,
      numeroResidenzaSanzionatoRequired: false,

      nomeSanzionatoPatriaPotestaRequired: false,
      cognomeSanzionatoPatriaPotestaRequired: false,
      comuneDiResidenzaSanzionatoPatriaPotestaRequired: false,
      indirizzoSanzionatoPatriaPotestaRequired: false,
      provinciaSanzionatoPatriaPotestaRequired: false,
      capSanzionatoPatriaPotestaRequired: false,
      numeroResidenzaSanzionatoPatriaPotestaRequired: false,

      rateScadute: [],

      tipologieSanzioni: [],
      listLocalita: [
        {
          idLocalita: 0,
          nomeLocalita: "",
          idLinea: 0,
          idArea: 0,
          idCliente: 0,
          importo: 0,
        },
      ],
      creaSanzione: {
        anagraficaTrasgressore: {
          nome: "",
          cognome: "",
          dataDiNascita: "",
          luogoDiNascita: "",
          isMinorenne: 0,
          numeroDocumento: "",
          dataRilascioDocumento: "",
          enteRilascioDocumento: "",
          comuneDiResidenza: "",
          inidirizzoDiResidenza: "",
          inidirizzoNumeroDiResidenza: "",
          frazione: "",
          provinciaDiResidenza: "",
          capDiResidenza: "",
          codiceFiscale: "",
        },
        anagraficaPotestaTrasgressore: {
          nome: "",
          cognome: "",
          dataDiNascita: "",
          isMinorenne: 0,
          dataRilascioDocumento: "",
          comuneDiResidenza: "",
          inidirizzoDiResidenza: "",
          inidirizzoNumeroDiResidenza: "",
          frazione: "",
          provinciaDiResidenza: "",
          capDiResidenza: "",
          enteRilascioDocumento: "",
        },
        anagraficaTipologiaSanzione: {
          idAnagrafiaTipolagiaSanzione: 1,
          nomeViolazione: "",
          importo: 0,
          importoRidotto: 0,
          aggiungiPrezzoTratta: 0,
          speseProcedura: 0,
        },
        localita: {
          idArea: 0,
          idCliente: 0,
          idLinea: 0,
          idLocalita: 0,
          importo: 0,
          nomeLocalita: "",
        },
        anagraficaStati: { idStato: 1, nomeStato: "caricato" },
        matricolaControllore: "",
        importo: 0,
        importoRidotto: 0,
        dataDiEmissione: new Date(),
        annotazioneControllore: "",
        isverbaleFattoABordo: 0,
      },
      filtro: {
        dataInizio: "",
        dataFine: "",
      },
    };
    this.geDataFormat = geDataFormat.bind(this);
    this.getColorState = getColorState.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.csvLinkEl = React.createRef();
  }

  componentDidMount() {
    toast.dismiss();
    this.dashboardSanzioneService = new DashboardSanzioneService();
    var search = this.props.location.search;
    var stato = "daLav";

    var filtroDate = JSON.parse(sessionStorage.getItem("filtroDate"));

    if (filtroDate) {
      this.state.filtro = filtroDate;
      sessionStorage.removeItem("filtroDate");
    } else {
      this.state.filtro.dataFine = moment(new Date()).format("YYYY-MM-DD")
      this.state.filtro.dataInizio = moment(this.state.filtro.dataFine, "YYYY-MM-DD").subtract(29, "d").format("YYYY-MM-DD")
    }

    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }
    this.getDataTable(
      stato,
      this.state.filtro.dataInizio,
      this.state.filtro.dataFine
    );

    if (stato === "rateizzati") {
      this.dashboardSanzioneService.getRateScadute((result) => {
        this.setState({ rateScadute: result.data });
        result.data.map((val) => {
        this.stringRateizza = <>Numero Sanzione: {val.toString()} <br/></>;
        this.strgss = this.strgss + this.stringRateizza;
        this.stringRateizza = this.stringRateizza.toString() + this.stringRateizza.toString();
        
        if (result.data.length <= 3) {
          toast.warning(<><span style={{fontSize:13}}>Numero sanzione con rata/e scadute:</span> <br></br><a onClick={()=>{
            // this.state.dataTableSanzione.map(valore => {
            //   if(valore.numeroSanzione === val){
            //     // this.state.idSanzionePerToast =valore.id;
            //     this.statoOnClickSanzione = {
            //       id:valore.id,
            //       statoSanzione:"Rateizzato",
            //     }
            //     sessionStorage.removeItem("rowSanzione");
            //     sessionStorage.setItem("rowSanzione", JSON.stringify(this.statoOnClickSanzione));
            
            //     // sessionStorage.removeItem("filtroDate");
            //     // sessionStorage.setItem("filtroDate", JSON.stringify(this.state.filtro));
            
            //     // this.props.history.push("/detailSanzione");
            //   }
            //   this.props.history.push("/detailSanzione");
            // })
            this.dashboardSanzioneService.getIdSanzioneByNumSanzione(val, (result) => {
              var detail = {
                id: result.data,
                statoSanzione:"Rateizzato",
              };
              sessionStorage.removeItem("rowSanzione");
              sessionStorage.setItem("rowSanzione", JSON.stringify(detail));
              toast.dismiss();
              this.props.history.push("/detailSanzione");
            })
          }}> {val} <img src={externalLink}  width={15} height={15}/></a></>, {
            autoClose: 50000,
            hideProgressBar: true,
            closeOnClick: true,
            style:{width:"100%"},
            
          });
        }
        if (result.data.length > 3) {
          toast.error(
             <><span style={{fontSize:13}}>Numero sanzione con rata/e scadute:</span> <br></br><a onClick={()=>{
              this.dashboardSanzioneService.getIdSanzioneByNumSanzione(val, (result) => {
                var detail = {
                  id: result.data,
                  statoSanzione:"Rateizzato",
                };
                sessionStorage.removeItem("rowSanzione");
                sessionStorage.setItem("rowSanzione", JSON.stringify(detail));
                toast.dismiss();
                this.props.history.push("/detailSanzione");
              })
             }}><u>{val}</u> <img src={externalLink} width={15} height={15} /></a><br></br></>
          , {
            autoClose: 50000,
            hideProgressBar: true,
            closeOnClick: true,
            style:{width:"100%"},
            // onClick:()=>{
            //   // this.state.dataTableSanzione.map(valore => {
            //   //   if(valore.numeroSanzione === val){
            //   //     // this.state.idSanzionePerToast =valore.id;
            //   //     this.statoOnClickSanzione = {
            //   //       id:valore.id,
            //   //       statoSanzione:"Rateizzato",
            //   //     }
            //   //     sessionStorage.removeItem("rowSanzione");
            //   //     sessionStorage.setItem("rowSanzione", JSON.stringify(this.statoOnClickSanzione));
              
            //   //     // sessionStorage.removeItem("filtroDate");
            //   //     // sessionStorage.setItem("filtroDate", JSON.stringify(this.state.filtro));
              
            //   //   }
            //   //   this.props.history.push("/detailSanzione");
            //   // })
            //   // this.statoOnClickSanzione = {
            //   //   id:this.state.idSanzionePerToast,
            //   //   statoSanzione:"Rateizzato",
            //   // }
            //   // sessionStorage.removeItem("rowSanzione");
            //   // sessionStorage.setItem("rowSanzione", JSON.stringify(this.statoOnClickSanzione));
          
            //   // // sessionStorage.removeItem("filtroDate");
            //   // // sessionStorage.setItem("filtroDate", JSON.stringify(this.state.filtro));
          
            //   // this.props.history.push("/detailSanzione");
            //   this.dashboardSanzioneService.getIdSanzioneByNumSanzione(val, (result) => {
            //     var detail = {
            //       id: result.data,
            //       statoSanzione:"Rateizzato",
            //     };
            //     sessionStorage.removeItem("rowSanzione");
            //     sessionStorage.setItem("rowSanzione", JSON.stringify(detail));
            //     toast.dismiss();
            //     this.props.history.push("/detailSanzione");
            //   })
            // }
          });
        }
        });

      });
       
      }
    }
    

    // this.getExportCSV(stato);

  createSanzione() {
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);

    this.state.creaSanzione.matricolaControllore = decoded.sub;
    // numeroMatricola: decoded.sub,

    this.state.creaSanzione.anagraficaTrasgressore.isMinorenne =
      this.state.creaSanzione.anagraficaTrasgressore.isMinorenne === true
        ? 1
        : 0;
    this.state.creaSanzione.anagraficaPotestaTrasgressore.isMinorenne =
      this.state.creaSanzione.anagraficaPotestaTrasgressore.isMinorenne === true
        ? 1
        : 0;

    this.dashboardSanzioneService.createSanzione(
      this.state.creaSanzione,
      this.onSuccesCreateSanzione.bind(this)
    );
  }

  getTipologiaMulte() {
    this.dashboardSanzioneService.getTipoSanzione(
      this.onSuccesGetSanzioni.bind(this)
    );
  }

  getExportCSV(stato) {
    this.dashboardSanzioneService.getExportCSV(
      stato,
      this.state.filtro.dataInizio,
      this.state.filtro.dataFine,
      this.onSuccesExportCSV.bind(this)
    );
  }
  // (dati.importo / 100).toFixed(2),
  onSuccesExportCSV(result) {
    //primi campi del CSV
    if(result.data.length <= 0){
      toast.error("Non ci sono record da esportare")
    }else {
      this.setState({dataTableSanzioneCSV:[]});
      result.data.map((dati) => {
        // console.log(dati.anagraficaTrasgressore.dataRilascioDocumento);
  
        if (
          dati.anagraficaTrasgressore.dataRilascioDocumento === null ||
          dati.anagraficaTrasgressore.dataRilascioDocumento === ""
        ) {
          this.dataRilascioDocumento = "";
        } else {
          this.dataRilascioDocumento = geDataFormat(
            dati.anagraficaTrasgressore.dataRilascioDocumento
          );
          // new Date(
          //   dati.anagraficaTrasgressore.dataRilascioDocumento
          // ).getDate() +
          // "/" +
          // new Date(
          //   dati.anagraficaTrasgressore.dataRilascioDocumento
          // ).getMonth() +
          // "/" +
          // new Date(
          //   dati.anagraficaTrasgressore.dataRilascioDocumento
          // ).getFullYear() +
          // " " +
          // new Date(
          //   dati.anagraficaTrasgressore.dataRilascioDocumento
          // ).getHours() +
          // ":" +
          // new Date(
          //   dati.anagraficaTrasgressore.dataRilascioDocumento
          // ).getMinutes();
        }
        if (
          dati.anagraficaPotestaTrasgressore.dataDiNascita === null ||
          dati.anagraficaPotestaTrasgressore.dataDiNascita === ""
        ) {
          this.anagraficaPotestaTrasgressoreDataDiNascita = "";
        } else {
          this.anagraficaPotestaTrasgressoreDataDiNascita = geDataFormat(
            dati.anagraficaPotestaTrasgressore.dataDiNascita
          );
          // new Date(dati.anagraficaPotestaTrasgressore.dataDiNascita).getDate() +
          // "/" +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataDiNascita
          // ).getMonth() +
          // "/" +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataDiNascita
          // ).getFullYear() +
          // " " +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataDiNascita
          // ).getHours() +
          // ":" +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataDiNascita
          // ).getMinutes();
        }
        if (
          dati.anagraficaPotestaTrasgressore.dataRilascioDocumento === null ||
          dati.anagraficaPotestaTrasgressore.dataRilascioDocumento === ""
        ) {
          this.anagraficaPotestaTrasgressoreDataRilascioDocumento = "";
        } else {
          this.anagraficaPotestaTrasgressoreDataRilascioDocumento = geDataFormat(
            dati.anagraficaPotestaTrasgressore.dataRilascioDocumento
          );
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataRilascioDocumento
          // ).getDate() +
          // "/" +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataRilascioDocumento
          // ).getMonth() +
          // "/" +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataRilascioDocumento
          // ).getFullYear() +
          // " " +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataRilascioDocumento
          // ).getHours() +
          // ":" +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataRilascioDocumento
          // ).getMinutes();
        }
  
        this.state.dataTableSanzioneCSV = [
          ...this.state.dataTableSanzioneCSV,
          {
            idSanzione: dati.idSanzione,
            numeroSanzione: dati.numeroSanzione,
            protocolloSanzione: dati.protocolloSanzione,
            matricolaControllore: dati.matricolaControllore,
            importo: (dati.importo / 100).toFixed(2),
            dataDiEmissione: geDataFormat(dati.dataDiEmissione),
            // new Date(dati.dataDiEmissione).getDate() +
            // "/" +
            // new Date(dati.dataDiEmissione).getMonth() +
            // "/" +
            // new Date(dati.dataDiEmissione).getFullYear() +
            // " " +
            // new Date(dati.dataDiEmissione).getHours() +
            // ":" +
            // new Date(dati.dataDiEmissione).getMinutes(),
            annotazioneControllore: dati.annotazioneControllore,
            isverbaleFattoABordo: dati.isverbaleFattoABordo,
            nomeViolazione: dati.anagraficaTipologiaSanzione.nomeViolazione,
            nomeStato: dati.anagraficaStati.nomeStato,
            idAnagraficaTrasgressore:
              dati.anagraficaTrasgressore.idAnagraficaTrasgressore,
            nomeTrasgressore: dati.anagraficaTrasgressore.nome,
            cognomeTrasgressore: dati.anagraficaTrasgressore.cognome,
            codiceFiscaleTrasgressore: dati.anagraficaTrasgressore.codiceFiscale,
            dataDiNascitaTrasgressore: this.dataRilascioDocumento,
            luogoDiNascitaTrasgressore:
              dati.anagraficaTrasgressore.luogoDiNascita,
            isMinorenneTrasgressore: dati.anagraficaTrasgressore.isMinorenne,
            numeroDocumentoTrasgressore:
              dati.anagraficaTrasgressore.numeroDocumento,
            enteRilascioDocumentoTrasgressore:
              dati.anagraficaTrasgressore.enteRilascioDocumento,
            inidirizzoDiResidenzaTrasgressore:
              dati.anagraficaTrasgressore.inidirizzoDiResidenza,
            inidirizzoNumeroDiResidenzaTrasgressore:
              dati.anagraficaTrasgressore.inidirizzoNumeroDiResidenza,
            capDiResidenzaTrasgressore:
              dati.anagraficaTrasgressore.capDiResidenza,
            provinciaDiResidenzaTrasgressore:
              dati.anagraficaTrasgressore.provinciaDiResidenza,
            idAnagraficaPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.idAnagraficaTrasgressore,
            nomePotestaTrasgressore: dati.anagraficaPotestaTrasgressore.nome,
            cognomePotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.cognome,
            codiceFiscalePotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.codiceFiscale,
            dataDiNascitaPotestaTrasgressore:
              this.anagraficaPotestaTrasgressoreDataDiNascita,
            luogoDiNascitaPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.luogoDiNascita,
            isMinorennePotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.isMinorenne,
            numeroDocumentoPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.numeroDocumento,
            dataRilascioDocumentoPotestaTrasgressore:
              this.anagraficaPotestaTrasgressoreDataRilascioDocumento,
            enteRilascioDocumentoPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.enteRilascioDocumento,
            inidirizzoDiResidenzaPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.inidirizzoDiResidenza,
            inidirizzoNumeroDiResidenzaPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza,
            capDiResidenzaPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.capDiResidenza,
            provinciaDiResidenzaPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.provinciaDiResidenza,
          },
        ];
      });
      // console.log(this.state.dataTableSanzioneCSV);
      this.setState(
        {
          dataTableSanzioneCSVLoad: this.state.dataTableSanzioneCSV,
        },
        () => {
          setTimeout(() => {
            this.csvLinkEl.current.link.click();
          });
        }
      );
    }

    
    // console.log(result.data);
  }

  onClickCSVDownLoad() {
    var search = this.props.location.search;
    var stato = "daLav";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }
    this.getExportCSV(stato);
    this.csvLink.current.link.click();
    // console.log(this.csvLink.current.link)
  }

  onSuccesGetSanzioni(result) {
    // console.log(result.data);
    this.setState((this.state.tipologieSanzioni = result.data));
  }

  onSuccesCreateSanzione(result) {
    // alert(result.data);
    // console.log(result);
    if (result.status === 200) {
      this.setState({
        showModalAggiungiSanzione: false,
        renderTableDataReload: true,
      });
      toast.success("Sanzione creata con successo", {
        position: toast.POSITION.TOP_RIGHT,
      });
      this.setState({
        showModalAggiungiSanzione: false,
        anagraficaSanzionato: false,
        isMinorenne: false,
        documentiSanzionati: false,
        residenzaSanzioanto: false,
        anagraficaSanzionatoPatriaPotesta: false,
        dettagliSanzione: false,
        buttonCreaSanzione: true,
        nomeSanzionatoRequired: false,
        cognomeSanzionatoRequired: false,
      });
      this.state.creaSanzione.importo = 0;
      var search = this.props.location.search;
      var stato = "daLav";
      if (search != null && search.includes("?")) {
        stato = search.substring(1, search.lenght);
      }
      this.getDataTable(
        stato,
        this.state.filtro.dataInizio,
        this.state.filtro.dataFine
      );
      this.state.creaSanzione.importo = 0;
      this.state.creaSanzione.annotazioneControllore = "";
      this.state.creaSanzione.anagraficaTrasgressore.dataDiNascita = "";
      this.state.creaSanzione.anagraficaTrasgressore.luogoDiNascita = "";
      this.state.creaSanzione.anagraficaTrasgressore.nome = "";
      this.state.creaSanzione.anagraficaTrasgressore.cognome = "";
      this.state.creaSanzione.anagraficaTrasgressore.capDiResidenza = "";
      this.state.creaSanzione.anagraficaTrasgressore.inidirizzoDiResidenza = "";
      this.state.creaSanzione.anagraficaTrasgressore.isMinorenne = 0;
      this.state.creaSanzione.anagraficaTrasgressore.numeroDocumento = "";
      this.state.creaSanzione.anagraficaTrasgressore.dataRilascioDocumento = "";
      this.state.creaSanzione.anagraficaTrasgressore.enteRilascioDocumento = "";
      this.state.creaSanzione.anagraficaTrasgressore.inidirizzoNumeroDiResidenza =
        "";
      this.state.creaSanzione.anagraficaTrasgressore.frazione = "";
      this.state.creaSanzione.anagraficaTrasgressore.provinciaDiResidenza = "";
      this.state.creaSanzione.anagraficaTrasgressore.codiceFiscale = "";
      this.state.creaSanzione.anagraficaTrasgressore.comuneDiResidenza = "";

      this.state.creaSanzione.anagraficaPotestaTrasgressore.nome = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.dataDiNascita = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;
      this.state.creaSanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.comuneDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.frazione = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.luogoDiNascita = "";
    } else {
      toast.error(
        "Qualcosa è andato storto durante la creazione della sanzione",
        { position: toast.POSITION.TOP_RIGHT }
      );
    }
  }
  getDataTable(stato, dataInizio, dataFine) {
    this.dashboardSanzioneService.getDataTableSanzioni(
      stato,
      dataInizio,
      dataFine,
      this.onSuccessLoadDataTableSanzione.bind(this)
    );
  }

  onSuccessLoadDataCharter(result) {
    this.setState((this.data = result));
  }
  onSuccessLoadDataTableSanzione(resultHeader, resultBody) {
    var sanzioni = resultBody;
    var numSanzioniInscadenza = 0;
    var numSanzioniMancanoDieciGiorni = 0;
    for (let i = 0; i < sanzioni.length; i++) {
      var sanzione = sanzioni[i];
      sanzione.importo = (sanzione.importo / 100).toFixed(2).toString().replace(".", ",") + " €"
      if(sanzione.minorenne){
        sanzione.minorenne = "Minorenne"
      }else{
        sanzione.minorenne = "Maggiorenne"
      }
      var allaScadenza = "-";
      if ("Caricato" === sanzioni[i].statoSanzione) {
        // console.log(sanzione);
        var diff = calculateTimeDifferenceTwoDates(
          new Date(),
          moment(sanzione.dataEmissione, "DD/MM/YYYY").toDate()
        );

        // allaScadenza = 60 - parseInt(diff, 10);
        // allaScadenza = 60 - parseInt(diff, 10);
        // if(new Date() === parseInt(diff, 10) ){
        // }

        var giorniAllaScadenza = parseInt(diff);
        allaScadenza = 60 - giorniAllaScadenza;

        if (
          parseInt(diff) >= 50 ||
          parseInt(diff) >= 55 ||
          parseInt(diff) >= 46
        ) {
          numSanzioniMancanoDieciGiorni += 1;
        }

        var val = "-";
        if (allaScadenza < 0) {
          val = "Scaduto";
          // numSanzioniInscadenza += 1;
        } else {
          val = "Scade tra " + allaScadenza + " giorni";
          if (allaScadenza < 5) numSanzioniInscadenza += 1;
        }

        if (allaScadenza <= 10) {
          // numSanzioniMancanoDieciGiorni += 1;
          // console.log(allaScadenza + " " + "simone");
        }
        sanzione.giorniAllaScadenza = val;
        // console.log(sanzione.giorniAllaScadenza);
      } else {
        sanzione.giorniAllaScadenza = " - ";
      }
    }
    // var mexError =
    //   "Attenzione " + numSanzioniInscadenza + " sanzioni in scadenza!";
    // if (numSanzioniInscadenza > 5)
    //   toast.warn(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else if (numSanzioniInscadenza > 10)
    //   toast.error(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else toast.info(numSanzioniInscadenza + " sanzioni in scadenza ");
    // this.setState((this.headerDataTableSanzione = resultHeader));
    // this.setState({ dataTableSanzioneCSV: resultBody });
    // this.setState({ dataTableSanzione: resultBody });
    // this.setState({ loading: false });
    if (
      this.props.location.search === "?daLav" ||
      this.props.location.search === ""
    ) {
      var mexError =
        "Attenzione " +
        numSanzioniMancanoDieciGiorni +
        " sanzioni in scadenza!";

      // if (numSanzioniMancanoDieciGiorni >= 5 )
      //   toast.warning(mexError, { position: toast.POSITION.TOP_RIGHT });
      // else if (numSanzioniMancanoDieciGiorni >= 10)
      //   toast.error(mexError, { position: toast.POSITION.TOP_RIGHT });
      // else toast.info(numSanzioniMancanoDieciGiorni + " sanzioni in scadenza ");

      switch (true) {
        case numSanzioniMancanoDieciGiorni >= 5 &&
          numSanzioniMancanoDieciGiorni <= 10:
          toast.warning(mexError, { position: toast.POSITION.TOP_RIGHT });
          break;
        case numSanzioniMancanoDieciGiorni >= 10:
          toast.error(mexError, { position: toast.POSITION.TOP_RIGHT });
          break;
        case numSanzioniMancanoDieciGiorni < 5:
          toast.info(numSanzioniMancanoDieciGiorni + " sanzioni in scadenza ");
          break;
        default:
          break;
      }
    }
    // console.log(resultBody);
    this.setState((this.headerDataTableSanzione = resultHeader));
    // this.setState({ dataTableSanzioneCSV: resultBody });
    this.setState({ dataTableSanzione: resultBody });
    this.setState({ loading: false });

    // console.log(mexError);
  }

  onRowClick(row) {
    sessionStorage.removeItem("rowSanzione");
    sessionStorage.setItem("rowSanzione", JSON.stringify(row));

    sessionStorage.removeItem("filtroDate");
    sessionStorage.setItem("filtroDate", JSON.stringify(this.state.filtro));
    toast.dismiss();
    this.props.history.push("/detailSanzione");
  }

  dataObj() {
    for (const item of this.state.dataTableSanzione) {
      item.clickEvent = () => this.onRowClick(item);
    }
    var data = {
      columns: this.headerDataTableSanzione,
      rows: this.state.dataTableSanzione,
    };
    return data;
  }

  renderTableData() {
    if (
      this.state.dataTableSanzione &&
      this.state.dataTableSanzione.length > 0
    ) {
      return (
        <CDBContainer>
          <CDBCard border>
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="col">Data Inizio: </div>
                  <div className="col">
                    <input
                      value={this.state.filtro.dataInizio}
                      type="date"
                      className="form-control"
                      onChange={this.onChangeDataInizio.bind(this)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="col">Data Fine: </div>
                  <div className="col">
                    <input
                      value={this.state.filtro.dataFine}
                      type="date"
                      className="form-control"
                      onChange={this.onChangeDataFine.bind(this)}
                    />
                  </div>
                </div>
                <div className="col">
                  {/* <div className="col">Filtri: </div> */}
                  <br></br>
                  <div className="col">
                    <button
                      className="btn btn-warning"
                      style={{ width: "100%" }}
                      onClick={() => {
                        var search = this.props.location.search;
                        var stato = "daLav";
                        if (search != null && search.includes("?")) {
                          stato = search.substring(1, search.lenght);
                        }
                        this.getDataTable(
                          stato,
                          this.state.filtro.dataInizio,
                          this.state.filtro.dataFine
                        );
                      }}
                    >
                      Applica Filtri
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <CDBCardBody>
              <CDBDataTable
                sortable={false}
                responsiveSm={true}
                responsiveMd={true}
                responsiveLg={true}
                pagesAmount={3}
                entriesLabel={""}
                infoLabel={["Mostra da", "a", "di", "sanzioni totali"]}
                paginationLabel={["<-", "->"]}
                striped
                bordered
                hover
                checkbox
                data={this.dataObj()}
                materialSearch
              />
            </CDBCardBody>
          </CDBCard>
        </CDBContainer>
      );
    } else {
      return (
        <>
          {" "}
          <div className="row form-group">
            <div className="col">
              <div className="col">Data Inizio: </div>
              <div className="col">
                <input
                  value={this.state.filtro.dataInizio}
                  type="date"
                  className="form-control"
                  onChange={this.onChangeDataInizio.bind(this)}
                />
              </div>
            </div>
            <div className="col">
              <div className="col">Data Fine :</div>
              <div className="col">
                <input
                  value={this.state.filtro.dataFine}
                  type="date"
                  className="form-control"
                  onChange={this.onChangeDataFine.bind(this)}
                />
              </div>
            </div>
            <div className="col">
              {/* <div className="col d-none">Filtri</div> */}
              <br></br>
              <div className="col">
                <button
                  className="btn btn-warning"
                  style={{ width: "100%" }}
                  onClick={() => {
                    var search = this.props.location.search;
                    var stato = "daLav";
                    if (search != null && search.includes("?")) {
                      stato = search.substring(1, search.lenght);
                    }
                    this.getDataTable(
                      stato,
                      this.state.filtro.dataInizio,
                      this.state.filtro.dataFine
                    );
                  }}
                >
                  Applica Filtri
                </button>
              </div>
            </div>
          </div>
          <br></br>
          <h4>Nessuna Sanzione Trovata</h4>
        </>
      );
    }
  }

  addSanzione() {
    this.getTipologiaMulte();
    this.listaLocalitaCeraSaznione();
    this.setState({ showModalAggiungiSanzione: true });
  }
  AnnulaAggiuntaSanzione() {
    this.setState({
      errorCFTrasgessore: false,
      errorCFTrasgessorePotesta: false,
      showModalAggiungiSanzione: false,
      anagraficaSanzionato: false,
      isMinorenne: false,
      documentiSanzionati: false,
      residenzaSanzioanto: false,
      anagraficaSanzionatoPatriaPotesta: false,
      dettagliSanzione: false,
      buttonCreaSanzione: true,
      nomeSanzionatoRequired: false,
      cognomeSanzionatoRequired: false,
    });
    this.state.creaSanzione.importo = 0;
    this.state.creaSanzione.annotazioneControllore = "";
    this.state.creaSanzione.anagraficaTrasgressore.dataDiNascita = "";
    this.state.creaSanzione.anagraficaTrasgressore.luogoDiNascita = "";
    this.state.creaSanzione.anagraficaTrasgressore.nome = "";
    this.state.creaSanzione.anagraficaTrasgressore.cognome = "";
    this.state.creaSanzione.anagraficaTrasgressore.capDiResidenza = "";
    this.state.creaSanzione.anagraficaTrasgressore.inidirizzoDiResidenza = "";
    this.state.creaSanzione.anagraficaTrasgressore.isMinorenne = 0;
    this.state.creaSanzione.anagraficaTrasgressore.numeroDocumento = "";
    this.state.creaSanzione.anagraficaTrasgressore.dataRilascioDocumento = "";
    this.state.creaSanzione.anagraficaTrasgressore.enteRilascioDocumento = "";
    this.state.creaSanzione.anagraficaTrasgressore.inidirizzoNumeroDiResidenza =
      "";
    this.state.creaSanzione.anagraficaTrasgressore.frazione = "";
    this.state.creaSanzione.anagraficaTrasgressore.provinciaDiResidenza = "";
    this.state.creaSanzione.anagraficaTrasgressore.codiceFiscale = "";
    this.state.creaSanzione.anagraficaTrasgressore.comuneDiResidenza = "";

    this.state.creaSanzione.anagraficaPotestaTrasgressore.nome = "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome = "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.dataDiNascita = "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;
    this.state.creaSanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
      "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.comuneDiResidenza =
      "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza =
      "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza =
      "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.frazione = "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza =
      "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza = "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.luogoDiNascita = "";
    this.setState({ showModalAggiungiSanzione: false });
  }
  confermaAggiuntaSanznione() {
    // console.log("aggiunta una sanzione alla lista");
    // console.log(!this.state.creaSanzione.anagraficaTrasgressore.nome)
    // console.log(!this.state.creaSanzione.anagraficaTrasgressore.cognome)
    // if (!this.state.creaSanzione.anagraficaTrasgressore.nome && !this.state.creaSanzione.anagraficaTrasgressore.cognome) {

    if (this.state.isMinorenne) {
      this.state.creaSanzione.anagraficaTrasgressore.isMinorenne = true;
      this.state.comuneDiResidenzaSanzionatoRequired = false;
      this.state.indirizzoSanzionatoRequired = false;
      this.state.provinciaSanzionatoRequired = false;
      this.state.capSanzionatoRequired = false;
      this.state.numeroResidenzaSanzionatoRequired = false;

      if (!this.state.creaSanzione.anagraficaTrasgressore.nome) {
        this.setState({ nomeSanzionatoRequired: true });
      }
      if (!this.state.creaSanzione.anagraficaTrasgressore.cognome) {
        this.setState({ cognomeSanzionatoRequired: true });
      }
      if (!this.state.creaSanzione.anagraficaPotestaTrasgressore.nome) {
        this.setState({ nomeSanzionatoPatriaPotestaRequired: true });
      }
      if (
        !this.state.creaSanzione.anagraficaPotestaTrasgressore
          .inidirizzoDiResidenza
      ) {
        this.setState({ indirizzoSanzionatoPatriaPotestaRequired: true });
      }
      if (
        !this.state.creaSanzione.anagraficaPotestaTrasgressore
          .provinciaDiResidenza
      ) {
        this.setState({ provinciaSanzionatoPatriaPotestaRequired: true });
      }
      if (
        !this.state.creaSanzione.anagraficaPotestaTrasgressore.comuneDiResidenza
      ) {
        this.setState({
          comuneDiResidenzaSanzionatoPatriaPotestaRequired: true,
        });
      }
      if (
        !this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza
      ) {
        this.setState({ capSanzionatoPatriaPotestaRequired: true });
      }
      if (
        !this.state.creaSanzione.anagraficaPotestaTrasgressore
          .inidirizzoNumeroDiResidenza
      ) {
        this.setState({ numeroResidenzaSanzionatoPatriaPotestaRequired: true });
      }
      if (!this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome) {
        this.setState({ cognomeSanzionatoPatriaPotestaRequired: true });
      } else if (
        this.state.creaSanzione.anagraficaTrasgressore.nome &&
        this.state.creaSanzione.anagraficaTrasgressore.cognome &&
        this.state.creaSanzione.anagraficaPotestaTrasgressore.nome &&
        this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome &&
        this.state.creaSanzione.anagraficaPotestaTrasgressore
          .inidirizzoDiResidenza &&
        this.state.creaSanzione.anagraficaPotestaTrasgressore
          .provinciaDiResidenza &&
        this.state.creaSanzione.anagraficaPotestaTrasgressore
          .comuneDiResidenza &&
        this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza &&
        this.state.creaSanzione.anagraficaPotestaTrasgressore
          .inidirizzoNumeroDiResidenza
      ) {
        this.setState({ nomeSanzionatoRequired: false });
        this.setState({ cognomeSanzionatoRequired: false });
        this.createSanzione();
      }
    } else {
      this.state.creaSanzione.anagraficaTrasgressore.isMinorenne = false;
      if (!this.state.creaSanzione.anagraficaTrasgressore.nome) {
        this.setState({ nomeSanzionatoRequired: true });
      }
      if (
        !this.state.creaSanzione.anagraficaTrasgressore.inidirizzoDiResidenza
      ) {
        this.setState({ indirizzoSanzionatoRequired: true });
      }
      if (
        !this.state.creaSanzione.anagraficaTrasgressore.provinciaDiResidenza
      ) {
        this.setState({ provinciaSanzionatoRequired: true });
      }
      if (!this.state.creaSanzione.anagraficaTrasgressore.comuneDiResidenza) {
        this.setState({ comuneDiResidenzaSanzionatoRequired: true });
      }
      if (!this.state.creaSanzione.anagraficaTrasgressore.capDiResidenza) {
        this.setState({ capSanzionatoRequired: true });
      }
      if (
        !this.state.creaSanzione.anagraficaTrasgressore
          .inidirizzoNumeroDiResidenza
      ) {
        this.setState({ numeroResidenzaSanzionatoRequired: true });
      }
      if (!this.state.creaSanzione.anagraficaTrasgressore.cognome) {
        this.setState({ cognomeSanzionatoRequired: true });
      } else if (
        this.state.creaSanzione.anagraficaTrasgressore.nome &&
        this.state.creaSanzione.anagraficaTrasgressore.cognome &&
        this.state.creaSanzione.anagraficaTrasgressore.inidirizzoDiResidenza &&
        this.state.creaSanzione.anagraficaTrasgressore.provinciaDiResidenza &&
        this.state.creaSanzione.anagraficaTrasgressore.comuneDiResidenza &&
        this.state.creaSanzione.anagraficaTrasgressore.capDiResidenza &&
        this.state.creaSanzione.anagraficaTrasgressore
          .inidirizzoNumeroDiResidenza
      ) {
        this.setState({ nomeSanzionatoRequired: false });
        this.setState({ cognomeSanzionatoRequired: false });

        this.createSanzione();
      }
    }

    // if (this.state.creaSanzione.anagraficaTrasgressore.cognome) {
    //
    // } else {
    //   this.setState({ cognomeSanzionatoRequired: false });
    // }

    //chiudere il modal e mandare i dati al BACK-END

    // this.setState({ showModalAggiungiSanzione: false });
  }

  changeTextNome(event) {
    this.state.creaSanzione.anagraficaTrasgressore.nome = capitalizeFirstLetter(
      event.target.value
    );
    this.state.nomeSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextCognome(event) {
    this.state.creaSanzione.anagraficaTrasgressore.cognome =
      capitalizeFirstLetter(event.target.value);
    this.state.cognomeSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  changeTextNomePatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.nome =
      capitalizeFirstLetter(event.target.value);
    this.state.nomeSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextCognomePatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome =
      capitalizeFirstLetter(event.target.value);
    this.state.cognomeSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextLuogoNascitaPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.luogoDiNascita =
      capitalizeFirstLetter(event.target.value);
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextNumResidenzaPatriaPotesa(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza =
      event.target.value;
    this.state.numeroResidenzaSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  changeTextComuneResidenzaPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.comuneDiResidenza =
      capitalizeFirstLetter(event.target.value);
    this.state.comuneDiResidenzaSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  changeTextIndirizzoResidenzaPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza =
      capitalizeFirstLetter(event.target.value);
    this.state.indirizzoSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextProvinciaResidenzaPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza =
      event.target.value.toString().toUpperCase();
    this.state.provinciaSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextCAPResidenzaPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza =
      event.target.value;
    this.state.capSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextDataRilascioPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
      event.target.value;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  changeTextDataNascitaPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.dataDiNascita =
      event.target.value;
    var dataOggi = new Date();
    let dataNascita = new Date(event.target.value);
    let anni = dataNascita.getFullYear();
    let anno = dataOggi.getFullYear();
    let eta = anno - anni;
    if (eta > 18) {
      //TODO rimuovere errore che e minnorenne
    } else {
      //TODO Mostrare errore che e minorenne
    }
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  changeTextTipologiaSanzione(event) {
    this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione =
      event.target.value;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextImporto(event) {
    // this.state.creaSanzione.importo = this.state.importoValue;
    this.state.creaSanzione.importo = event.target.value;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextTratta(event) {
    this.state.creaSanzione.tratta = event.target.value;
    this.setState({
      creaSanzione: this.state.creaSanzione,
    });
  }
  changeTextDataNascita(event) {
    this.state.creaSanzione.anagraficaTrasgressore.dataDiNascita =
      event.target.value;
    var dataOggi = new Date();
    let dataNascita = new Date(event.target.value);
    let anni = dataNascita.getFullYear();
    let anno = dataOggi.getFullYear();
    let eta = anno - anni;
    if (eta > 18) {
      this.state.isMinorenne = false;
      this.state.creaSanzione.anagraficaPotestaTrasgressore.nome = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.dataDiNascita = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;
      this.state.creaSanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.comuneDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.frazione = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.luogoDiNascita = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.codiceFiscale = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.numeroDocumento =
        "";
    } else {
      this.state.isMinorenne = true;
      this.state.comuneDiResidenzaSanzionatoRequired = false;
      this.state.indirizzoSanzionatoRequired = false;
      this.state.capSanzionatoRequired = false;
      this.state.numeroResidenzaSanzionatoRequired = false;
      this.state.provinciaSanzionatoRequired = false;
      this.state.creaSanzione.anagraficaPotestaTrasgressore.nome = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.dataDiNascita = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;
      this.state.creaSanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.comuneDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.frazione = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.luogoDiNascita = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.codiceFiscale = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.numeroDocumento =
        "";
    }
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextLuogoNascita(event) {
    this.state.creaSanzione.anagraficaTrasgressore.luogoDiNascita =
      capitalizeFirstLetter(event.target.value);
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextCodiceFiscale(event) {
    this.state.creaSanzione.anagraficaTrasgressore.codiceFiscale =
      event.target.value.toString().toUpperCase();
    if (
      !validCF.test(
        this.state.creaSanzione.anagraficaTrasgressore.codiceFiscale
      )
    ) {
      this.setState({ errorCFTrasgessore: true });
    } else {
      this.setState({ errorCFTrasgessore: false });
    }
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextCodiceFiscaleP(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.codiceFiscale =
      event.target.value.toString().toUpperCase();
    if (
      !validCF.test(
        this.state.creaSanzione.anagraficaPotestaTrasgressore.codiceFiscale
      )
    ) {
      this.setState({ errorCFTrasgessorePotesta: true });
    } else {
      this.setState({ errorCFTrasgessorePotesta: false });
    }
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextNumeroDocumento(event) {
    this.state.creaSanzione.anagraficaTrasgressore.numeroDocumento =
      event.target.value.toString().toUpperCase();
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextNumeroDocumentoP(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.numeroDocumento =
      event.target.value.toString().toUpperCase();
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextDataRilascio(event) {
    this.state.creaSanzione.anagraficaTrasgressore.dataRilascioDocumento =
      event.target.value;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextEnteRilascio(event) {
    this.state.creaSanzione.anagraficaTrasgressore.enteRilascioDocumento =
      capitalizeFirstLetter(event.target.value);
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextEnteRilascioP(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.enteRilascioDocumento =
      capitalizeFirstLetter(event.target.value);
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextComuneResidenza(event) {
    this.state.creaSanzione.anagraficaTrasgressore.comuneDiResidenza =
      capitalizeFirstLetter(event.target.value);
    this.state.comuneDiResidenzaSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextIndirizzoResidenza(event) {
    this.state.creaSanzione.anagraficaTrasgressore.inidirizzoDiResidenza =
      capitalizeFirstLetter(event.target.value);
    this.state.indirizzoSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextNumeroResidenza(event) {
    this.state.creaSanzione.anagraficaTrasgressore.inidirizzoNumeroDiResidenza =
      event.target.value;
    this.state.numeroResidenzaSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextCAPResidenza(event) {
    this.state.creaSanzione.anagraficaTrasgressore.capDiResidenza =
      event.target.value;
    this.state.capSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextProvinciaResidenza(event) {
    this.state.creaSanzione.anagraficaTrasgressore.provinciaDiResidenza =
      event.target.value.toString().toUpperCase();
    this.state.provinciaSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextAnnotazione(event) {
    this.state.creaSanzione.annotazioneControllore = capitalizeFirstLetter(
      event.target.value
    );
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  sectionInputMulta(event) {
    // console.log(event.target.value);
    // if (event.target.value === "0") {
    //   this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione =
    //     "1 Senza biglietto";
    //   this.state.creaSanzione.importo = 5800;
    // } else if (event.target.value === "1") {
    //   this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione =
    //     " 2 Documento di viaggio fuori tratta";
    //   this.state.creaSanzione.importo = 5300;
    // } else if (event.target.value === "2") {
    //   this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione =
    //     " 3 Documento di viaggio inregolare ";
    //   this.state.creaSanzione.importo = 5800;
    // } else if (event.target.value === "3") {
    //   this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione =
    //     " 4 Abbonamento dimenticato ";
    //   this.state.creaSanzione.importo = 5800;
    // }
    if (event.target.value === "-1") {
      this.state.anagraficaSanzionato = false;
      this.state.dettagliSanzione = false;
      this.state.creaSanzione.importo = 0;
    }
    //forse va bene
    this.state.tipologieSanzioni.map((tipoSanzione, index) => {
      if (event.target.value === tipoSanzione.nomeViolazione) {
        this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione =
          event.target.value;

        var arrayDiIMportoRidotto = tipoSanzione.importo.toString().split("");

        // // console.log(arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1]);
        // if (arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1] === "0") {
        //   this.state.creaSanzione.importo = tipoSanzione.importo + "0";
        // }else{
        this.state.creaSanzione.importo = tipoSanzione.importo;
        this.state.creaSanzione.importoRidotto = tipoSanzione.importoRidotto;
        // }

        this.state.creaSanzione.anagraficaTipologiaSanzione.idAnagrafiaTipolagiaSanzione =
          tipoSanzione.idAnagrafiaTipolagiaSanzione;
      }
    });

    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  sectionInputTratta(event) {
    // console.log(event.target.value);

    if (
      event.target.value > "-1" &&
      this.state.creaSanzione.importo > 0
      // this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione
      //   .length > 0
    ) {
      this.state.anagraficaSanzionato = true;
      this.state.dettagliSanzione = true;
      this.state.buttonCreaSanzione = false;
    } else if (event.target.value === "-1") {
      this.state.anagraficaSanzionato = false;
      this.state.dettagliSanzione = false;
    } else if (
      this.state.creaSanzione.importo === "0" &&
      this.state.creaSanzione.importo === "0"
    ) {
      this.state.anagraficaSanzionato = false;
      this.state.dettagliSanzione = false;
    }

    // this.state.creaSanzione.localita = event.target.value;
    // console.log(this.state.creaSanzione.localita.idArea)
    this.state.listLocalita.map((dati, index) => {
      if (parseInt(event.target.value) === index) {
        this.state.creaSanzione.localita.idArea = dati.idArea;
        this.state.creaSanzione.localita.idCliente = dati.idCliente;
        this.state.creaSanzione.localita.idLocalita = dati.idLocalita;
        this.state.creaSanzione.localita.importo = dati.importo;
        this.state.creaSanzione.localita.nomeLocalita = dati.nomeLocalita;
        this.state.creaSanzione.localita.idLinea = dati.idLinea;
      }
    });
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  listaLocalitaCeraSaznione() {
    this.dashboardSanzioneService.getListLocalita((result) => {
      if (result.status === 200) {
        this.setState({ listLocalita: result.data });
      }
    });
  }

  showModalAggiungiSanzione() {
    return (
      <>
        <Modal size="xl" show={this.state.showModalAggiungiSanzione}>
          <Modal.Header>
            <Modal.Title>Crea Sanzione</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <fieldset className="border p-2">
              <legend className="w-auto" style={{ color: "#4e73df" }}>
                Tipo Sanzione
              </legend>
              <br></br>
              <br></br>
              <div className="row">
                <div className="col-sm-4">Tipologia Sanzione</div>
                <div className="col-sm-8">
                  {/* <div className="select-container">
                    <select
                      onChange={this.sectionInputMulta.bind(this)}
                      className="form-select"
                      disabled={this.state.disableInput}
                    >
                      <option value={""} className="">
                        Scelta Tipologia Sanzione
                      </option>
                      <option value={0}> 1 Senza biglietto </option>
                      <option value={1}>
                        {" "}
                        2 Documento di viaggio fuori tratta
                      </option>
                      <option value={2}>
                        {" "}
                        3 Documento di viaggio inregolare
                      </option>
                      <option value={3}>4 Abbonamento dimenticato </option>
                    </select>
                  </div> */}
                  <div className="select-container">
                    <select
                      onChange={this.sectionInputMulta.bind(this)}
                      className="form-select"
                      disabled={this.state.disableInput}
                    >
                      <option value="-1"></option>
                      {this.state.tipologieSanzioni.map((multa, val) => {
                        return (
                          <>
                            {/* <option value={val -1}>{multa.nomeViolazione}</option> */}
                            <option value={multa.nomeViolazione}>
                              {multa.nomeViolazione}
                            </option>
                          </>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <br></br>
              <div className="row">
                <div className="col-sm-4">Importo</div>
                <div className="col-sm-8">
                  {/* <div className="select-container"> */}
                  {/* <div className="input-group mb-3"> */}
                  {/* <div className="input-group-prepend"> */}
                  {/* <span className="input-group-text">€</span> */}
                  {/* </div> */}
                  <h5 type="number">
                    €{" "}
                    {parseFloat(this.state.creaSanzione.importo / 100)
                      .toFixed(2)
                      .toString()
                      .replace(".", ",")}
                    {/* {Math.round(this.state.creaSanzione.importo)} */}
                  </h5>
                  {/* </div> */}
                  {/* </div> */}
                </div>
              </div>
              <br></br>
              {this.state.creaSanzione.importo > 0 ? (
                <div className="row">
                  <div className="col-sm-4">Localita</div>
                  <div className="col-sm-8">
                    <div className="select-container">
                      <div className="select-container">
                        <select
                          onChange={this.sectionInputTratta.bind(this)}
                          className="form-select"
                          disabled={this.state.disableInput}
                        >
                          <option selected value={"-1"} className="">
                            {"Percorenza"}
                          </option>
                          {this.state.listLocalita.map((dati, index) => {
                            // console.log(this.state.listLocalita);
                            return (
                              <>
                                <option
                                  value={index}
                                  className=""
                                  onClick={() => {}}
                                >
                                  {dati.nomeLocalita}
                                </option>
                              </>
                            );
                          })}
                          {/* <option value={0}>Varese - Treviglio</option>
                          <option value={1}>Treviglio - Varese</option> */}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <br></br>
            </fieldset>
            {this.state.anagraficaSanzionato ? (
              <fieldset className="border p-2">
                <legend className="w-auto" style={{ color: "#4e73df" }}>
                  Anagrafica Sanzionato
                </legend>
                <br></br>
                <br></br>
                <div className="row">
                  <div className="col">
                    <label>
                      Nome <small className="text-danger">*</small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaTrasgressore.nome
                      }
                      onChange={this.changeTextNome.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.nomeSanzionatoRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "12px" }}>
                          <li>Il campo Nome sanzionato è obbligatorio</li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col">
                    <label>
                      Cognome <small className="text-danger">*</small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaTrasgressore.cognome
                      }
                      onChange={this.changeTextCognome.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.cognomeSanzionatoRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>Il campo Cognome sanzionato è obbligatorio</li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col">
                    <label>Data Nascita</label>
                    <input
                      className="form-control"
                      type="date"
                      value={
                        this.state.creaSanzione.anagraficaTrasgressore
                          .dataDiNascita
                      }
                      onChange={this.changeTextDataNascita.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                  </div>
                  <div className="col">
                    <label className="col">Luogo Nascita</label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaTrasgressore
                          .luogoDiNascita
                      }
                      onChange={this.changeTextLuogoNascita.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                  </div>
                </div>
                {/* <legend className="w-auto" style={{ color: "#4e73df" }}>
                  Residenza Sanzionato
                </legend> */}
                {/* <br></br> */}
                <br></br>
                <div className="row">
                  <div className="col">
                    <label>
                      Comune di Residenza{" "}
                      <small className="text-danger">*</small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaTrasgressore
                          .comuneDiResidenza
                      }
                      onChange={this.changeTextComuneResidenza.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.comuneDiResidenzaSanzionatoRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>
                            Il campo Comune di residenza sanzionato è
                            obbligatorio
                          </li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col">
                    <label>
                      Indirizzo Sanzionato{" "}
                      <small className="text-danger">*</small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaTrasgressore
                          .inidirizzoDiResidenza
                      }
                      onChange={this.changeTextIndirizzoResidenza.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.indirizzoSanzionatoRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>
                            Il campo Indirizzo di residenza sanzionato è
                            obbligatorio
                          </li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col">
                    <label>
                      Provincia <small className="text-danger">*</small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaTrasgressore
                          .provinciaDiResidenza
                      }
                      onChange={this.changeTextProvinciaResidenza.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.provinciaSanzionatoRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>
                            Il campo Provincia di residenza sanzionato è
                            obbligatorio
                          </li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col">
                    <label className="col">
                      CAP <small className="text-danger">*</small>
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      value={
                        this.state.creaSanzione.anagraficaTrasgressore
                          .capDiResidenza
                      }
                      onChange={this.changeTextCAPResidenza.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.capSanzionatoRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>
                            Il campo CAP di residenza sanzionato è obbligatorio
                          </li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col">
                    <label className="col">
                      Numero Residenza <small className="text-danger">*</small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaTrasgressore
                          .inidirizzoNumeroDiResidenza
                      }
                      onChange={this.changeTextNumeroResidenza.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.numeroResidenzaSanzionatoRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>
                            Il campo Numero di residenza sanzionato è
                            obbligatorio
                          </li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {/* <legend className="w-auto" style={{ color: "#4e73df" }}>
                  Documenti Sanzionato
                </legend> */}
                {/* <br></br> */}
                <br></br>
                <div className="row">
                  <div className="col">
                    <label>Codice Fiscale</label>
                    <input
                      className="form-control"
                      type="text"
                      maxLength="16"
                      value={
                        this.state.creaSanzione.anagraficaTrasgressore
                          .codiceFiscale
                      }
                      onChange={this.changeTextCodiceFiscale.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.errorCFTrasgessore ? (
                      <>
                        <small className="text-danger">
                          Il formato del Codice Fiscale è sbagliato
                        </small>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="col">
                    <label>Numero Documento</label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaTrasgressore
                          .numeroDocumento
                      }
                      onChange={this.changeTextNumeroDocumento.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col">
                    <label>Data Rilascio</label>
                    <input
                      className="form-control"
                      type="date"
                      value={
                        this.state.creaSanzione.anagraficaTrasgressore
                          .dataRilascioDocumento
                      }
                      onChange={this.changeTextDataRilascio.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                  </div>
                  <div className="col">
                    <label className="col">Rilasciato Da</label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaTrasgressore
                          .enteRilascioDocumento
                      }
                      onChange={this.changeTextEnteRilascio.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                  </div>
                </div>
              </fieldset>
            ) : (
              ""
            )}
            {this.state.isMinorenne ? (
              <fieldset className="border p-2">
                <legend className="w-auto" style={{ color: "#4e73df" }}>
                  Anagrafica Patria Potesta Sanzionato
                </legend>
                <br></br>
                <br></br>
                <div className="row">
                  <div className="col">
                    <label>
                      Nome <small className="text-danger">*</small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaPotestaTrasgressore
                          .nome
                      }
                      onChange={this.changeTextNomePatriaPotesta.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.nomeSanzionatoPatriaPotestaRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>Il campo Nome Patria Potesta è obbligatorio</li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col">
                    <label>
                      Cognome <small className="text-danger">*</small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaPotestaTrasgressore
                          .cognome
                      }
                      onChange={this.changeTextCognomePatriaPotesta.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.cognomeSanzionatoPatriaPotestaRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>
                            Il campo Cognome Patria Potesta è obbligatorio
                          </li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col">
                    <label>Data Nascita</label>
                    <input
                      className="form-control"
                      type="date"
                      value={
                        this.state.creaSanzione.anagraficaPotestaTrasgressore
                          .dataDiNascita
                      }
                      onChange={this.changeTextDataNascitaPatriaPotesta.bind(
                        this
                      )}
                      // disabled={this.state.disableInput}
                    ></input>
                  </div>
                  <div className="col">
                    <label className="col">Luogo Nascita</label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaPotestaTrasgressore
                          .luogoDiNascita
                      }
                      onChange={this.changeTextLuogoNascitaPatriaPotesta.bind(
                        this
                      )}
                      // disabled={this.state.disableInput}
                    ></input>
                  </div>
                </div>
                {/* <legend className="w-auto" style={{ color: "#4e73df" }}>
                  Residenza Sanzionato
                </legend> */}
                {/* <br></br> */}
                <br></br>
                <div className="row">
                  <div className="col">
                    <label>
                      Comune di Residenza{" "}
                      <small className="text-danger">*</small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaPotestaTrasgressore
                          .comuneDiResidenza
                      }
                      onChange={this.changeTextComuneResidenzaPatriaPotesta.bind(
                        this
                      )}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state
                      .comuneDiResidenzaSanzionatoPatriaPotestaRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>
                            Il campo Comune di residenza Patria Potesta è
                            obbligatorio
                          </li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col">
                    <label>
                      Indirizzo <small className="text-danger">*</small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaPotestaTrasgressore
                          .inidirizzoDiResidenza
                      }
                      onChange={this.changeTextIndirizzoResidenzaPatriaPotesta.bind(
                        this
                      )}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.indirizzoSanzionatoPatriaPotestaRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>
                            Il campo Indirizzo di residenza Patria Potesta è
                            obbligatorio
                          </li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col">
                    <label>Provincia</label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaPotestaTrasgressore
                          .provinciaDiResidenza
                      }
                      onChange={this.changeTextProvinciaResidenzaPatriaPotesta.bind(
                        this
                      )}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.provinciaSanzionatoPatriaPotestaRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>
                            Il campo Provincia di residenza Patria Potesta è
                            obbligatorio
                          </li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col">
                    <label className="col">
                      CAP <small className="text-danger">*</small>
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      maxLength="5"
                      value={
                        this.state.creaSanzione.anagraficaPotestaTrasgressore
                          .capDiResidenza
                      }
                      onChange={this.changeTextCAPResidenzaPatriaPotesta.bind(
                        this
                      )}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.capSanzionatoPatriaPotestaRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>
                            Il campo CAP di residenza Patria Potesta è
                            obbligatorio
                          </li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col">
                    <label className="col-md-10">
                      Numero di residenza{" "}
                      <small className="text-danger">*</small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaPotestaTrasgressore
                          .inidirizzoNumeroDiResidenza
                      }
                      onChange={this.changeTextNumResidenzaPatriaPotesa.bind(
                        this
                      )}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state
                      .numeroResidenzaSanzionatoPatriaPotestaRequired ? (
                      <small className="text-danger">
                        <ul style={{ fontSize: "11px" }}>
                          <li>
                            Il campo Numero di residenza Patria Potesta è
                            obbligatorio
                          </li>
                        </ul>
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {/* <legend className="w-auto" style={{ color: "#4e73df" }}>
                  Documenti Sanzionato
                </legend> */}
                {/* <br></br> */}
                <br></br>
                <div className="row">
                  <div className="col">
                    <label>
                      Codice Fiscale <small className="text-danger"></small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaPotestaTrasgressore
                          .codiceFiscale
                      }
                      // value={""}
                      maxLength="16"
                      onChange={this.changeTextCodiceFiscaleP.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                    {this.state.errorCFTrasgessorePotesta ? (
                      <>
                        <small className="text-danger">
                          Il formato del Codice Fiscale è sbagliato
                        </small>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="col">
                    <label>
                      Numero Documento <small className="text-danger"></small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaPotestaTrasgressore
                          .numeroDocumento
                      }
                      // value={""}
                      onChange={this.changeTextNumeroDocumentoP.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col">
                    <label>Data Rilascio </label>
                    <input
                      className="form-control"
                      type="date"
                      value={
                        this.state.creaSanzione.anagraficaPotestaTrasgressore
                          .dataRilascioDocumento
                      }
                      onChange={this.changeTextDataRilascioPatriaPotesta.bind(
                        this
                      )}
                      // disabled={this.state.disableInput}
                    ></input>
                  </div>
                  <div className="col">
                    <label className="col">
                      Rilasciato Da <small className="text-danger"></small>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.creaSanzione.anagraficaPotestaTrasgressore
                          .enteRilascioDocumento
                      }
                      // value={""}
                      onChange={this.changeTextEnteRilascioP.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                  </div>
                </div>
              </fieldset>
            ) : (
              ""
            )}
            {this.state.dettagliSanzione ? (
              <fieldset className="border p-2">
                <legend className="w-auto" style={{ color: "#4e73df" }}>
                  Dettaglio Sanzione
                </legend>
                <br></br>
                <br></br>
                <div className="row">
                  <div className="col">
                    <label>Eventuale Nota Sanzione</label>
                    <input
                      className="form-control"
                      type="textarea"
                      value={this.state.creaSanzione.annotazioneControllore}
                      onChange={this.changeTextAnnotazione.bind(this)}
                      // disabled={this.state.disableInput}
                    ></input>
                  </div>
                  <div className="col">
                    <label>Allegati</label>
                    <input
                      className="form-control"
                      type="file"
                      value={""}
                      // onChange={this.changeTextNome.bind(this)}
                      // disabled={this.state.disableInput}
                      onClick={() => {
                        alert("Funzionalita in sviluppo ... ");
                      }}
                    ></input>
                  </div>
                </div>
              </fieldset>
            ) : (
              ""
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.AnnulaAggiuntaSanzione.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              onClick={this.confermaAggiuntaSanznione.bind(this)}
              disabled={this.state.buttonCreaSanzione}
            >
              Crea sanzione
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  onChangeDataInizio(event) {
    this.state.filtro.dataInizio = event.target.value;
    this.setState({ filtro: this.state.filtro });
  }

  onChangeDataFine(event) {
    this.state.filtro.dataFine = event.target.value;
    this.setState({ filtro: this.state.filtro });

    // var search = this.props.location.search;
    // var stato = "daLav";
    // if (search != null && search.includes("?")) {
    //   stato = search.substring(1, search.lenght);
    // }
    // this.getDataTable(
    //   stato,
    //   this.state.filtro.dataInizio,
    //   this.state.filtro.dataFine
    // );
  }

  render() {
    // const params = new URLSearchParams(this.props.location.search);
    // console.log(params)
    var search = this.props.location.search;
    var stato = "daLav";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }
    // console.log(stato)

    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
              Gestione Sanzioni<br></br>
              <small
                style={{ fontSize: "14px" }}
                className="mb-2 text-gray-800"
              >
                Sanzioni &#8594;{" "}
                {stato === "daLav"
                  ? "Da Lavorare"
                  : stato === "inLav"
                  ? "In Lavorazione"
                  : stato === "pagate"
                  ? "Pagate"
                  : stato === "ravvedimentoOperoso"
                  ? "Ravvedimento Operoso"
                  : stato === "agliAtti"
                  ? "Agli Atti"
                  : stato === "annullate"
                  ? "Annullate"
                  : stato === "altri"
                  ? "Altri"
                  : stato === "rateizzati"
                  ? "Rateizzati"
                  : stato === "postalizzate"
                  ? "Postalizzate"
                  : ""}
              </small>
            </h1>
            <button
              type="button"
              class="btn btn-warning"
              onClick={this.addSanzione.bind(this)}
              disabled
            >
              {" "}
              <i className="fas fa-plus fa-sm text-white"></i> &nbsp;Aggiungi
              sanzione
            </button>
            {this.showModalAggiungiSanzione()}
            {/* onClick={this.onClickCSVDownLoad.bind(this)} */}
            <button
              type="button"
              class="btn btn-warning"
              onClick={this.onClickCSVDownLoad.bind(this)}
            >
              {" "}
              <i className="fas fa-download fa-sm text-white"></i> &nbsp;Esporta
              Sanzioni
            </button>
            <CSVLink
              data={this.state.dataTableSanzioneCSVLoad}
              separator={";"}
              // onClick={this.onClickCSVDownLoad.bind(this)}
              ref={this.csvLinkEl}
              filename={
                stato === "daLav"
                  ? "Da Lavorare.csv"
                  : stato === "inLav"
                  ? "In Lavorazione.csv"
                  : stato === "pagate"
                  ? "Pagate.csv"
                  : stato === "ravvedimentoOperoso"
                  ? "Ravvedimento Operoso.csv"
                  : stato === "agliAtti"
                  ? "Agli Atti.csv"
                  : stato === "annullate"
                  ? "Annullate.csv"
                  : stato === "altri"
                  ? "Altri.csv"
                  : ""
              }
            />

            {/* </CSVLink> */}
          </div>
          {/* <br />
          <br /> */}

          <div className="col">{this.renderTableData()}</div>
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(Home);
